import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheck } from 'react-icons/fa6';
import axios from 'axios';
import './ForgetPassword.css';

function ForgotPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [resetLink, setResetLink] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleUserNameChange = (e) => {
    setUsername(e.target.value);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const getErrorMessage = (detail) => {
    const text = typeof detail === 'string' ? detail : '';
    if (text.toLowerCase().includes('does not exist')) {
      return 'ไม่พบอีเมลของท่าน กรุณาตรวจสอบอีเมลอีกครั้งค่ะ';
    }
    return text || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งค่ะ';
  };

  const handleButtonClick = async () => {
    if (username.trim() === '') {
      alert('กรุณากรอกอีเมล');
    } else if (!validateEmail(username)) {
      alert('กรุณากรอกอีเมลให้ถูกต้อง');
    } else {
      try {
        const payload = new URLSearchParams({
          user_email: username,
        });
        const response = await axios.post('https://sso-uficon-xuvbdxggia-uc.a.run.app/forgot-password', payload);
        const detail = response.data?.detail;
        if (detail) {
          setErrorMessage(getErrorMessage(detail));
          return;
        }
        setResetLink(response.data.reset_link); // Assume response.data.reset_link contains the URL with the token
        setShowMessage(true);
      } catch (error) {
        console.error('Error sending reset link:', error);
        setErrorMessage(getErrorMessage(error.response?.data?.detail));
      }
    }
  };
  

  return (
    <div className="App">
      <header className="App-header">
      <div
                  style={{
                    width: '100%',
                    maxWidth: '500px',
                    minWidth: '300px',
                    height: '100%',
                    backgroundColor: '#f2f3f5',
                    padding: '50px',
                    boxSizing: 'border-box',
                  }}
                >
                  <img src="/assets/logo U-01.png" alt="Logo" className="logo" />
                  <div className="forgot-text">ลืมรหัสผ่าน</div>
                  <div className="forgot-text-eng">forgot Password</div>

                  {!showMessage && (
          <>
            <div className="policy-header-forgot">
              <div>กรุณากรอกอีเมล เพื่อคุณจะได้รับลิงก์เพื่อสร้างรหัสผ่านใหม่ทางอีเมล</div>         
            </div>
            <div className="input-group password-group">
              <div className="input-label" style={{ marginTop: '30px' }}>Your Email</div>
              <div className="password-container">
                <input
                  type="text"
                  className="input-field"
                  placeholder='example@email.com'
                  value={username}
                  onChange={handleUserNameChange}
                />
              </div>
            </div>
            <div className="input-group">
              <button className="login-button" onClick={handleButtonClick}>เปลี่ยนรหัสผ่าน</button>
            </div>
          </>
        )}

        {showMessage && (
          <div className="message-container">
            <div className="success-message">
              <FaCheck style={{ color: 'green', marginRight: '8px' }} />
              อีเมลสำหรับการเปลี่ยนรหัสผ่านถูกส่งแล้ว
            </div>
            <div className="success-header">
              <div>ส่งอีเมลล้างค่ารหัสผ่านไปทางอีเมลที่ตั้งค่าไว้ในบัญชีแล้ว</div> 
              <div> อาจใช้เวลาสักครู่กว่าท่านจะได้รับอีเมลฉบับดังกล่าว</div>
              <div> และกรุณา รออย่างน้อย 10 นาทีก่อนที่จะร้องขอเปลี่ยนรหัสผู้ใช้ครั้งใหม่</div>
            </div>
            {resetLink && (
              <div className="reset-link">
                <a href={resetLink} target="_blank" rel="noopener noreferrer"></a>
              </div>
            )}
          </div>
        )}
                </div>

        {errorMessage && (
          <div className="popup-overlay" onClick={() => setErrorMessage('')}>
            <div className="popup-box" onClick={(e) => e.stopPropagation()}>
              <div className="popup-message">{errorMessage}</div>
              <div className="popup-buttons">
                <button className="cancel-btn" onClick={() => setErrorMessage('')}>ตกลง</button>
              </div>
            </div>
          </div>
        )}

      </header>
    </div>
  );
}

export default ForgotPassword;
